/**
 * Account Aggregator View Drawer
 *
 * Displays aggregator details in a side drawer.
 */

import React from 'react';
import { Drawer, DrawerContent, DrawerHeader, DrawerOverlay } from 'equal-ds-ui';
import type { AccountAggregatorViewDrawerProps } from '../../../types/account-aggregator';

export const AccountAggregatorViewDrawer: React.FC<AccountAggregatorViewDrawerProps> = ({
  isOpen,
  record,
  onClose,
}) => {
  if (!isOpen || !record) {
    return null;
  }

  const detailItems = [
    { label: 'AA Handle', value: record.aa_handle },
    { label: 'AA Code', value: record.account_aggregator_code },
    { label: 'Address', value: record.address },
    { label: 'APK URL', value: record.apk_url },
    { label: 'Base URL', value: record.base_url },
    { label: 'Web URL', value: record.web_url },
    { label: 'Support Email', value: record.email },
    { label: 'Contact Person', value: record.contact_person },
    { label: 'Mobile Number', value: record.phone_no },
    { label: 'Created On', value: record.createdAt },
    { label: 'Updated On', value: record.updatedAt },
  ];

  return (
    <>
      <DrawerOverlay />
      <Drawer variant="overlay" width="480px">
        <DrawerHeader className="border-b border-border-default pb-4" onClose={onClose}>
          <div>
            <h2 className="text-xl font-semibold text-text-primary">
              Details of {record.account_aggregator_name}
            </h2>
            <p className="text-sm text-text-secondary mt-1">
              Account aggregator summary information
            </p>
          </div>
        </DrawerHeader>
        <DrawerContent className="p-6 space-y-4 overflow-y-auto">
          {detailItems.map((item) => (
            <div key={item.label} className="flex items-start gap-4">
              <span className="w-40 text-sm font-medium text-text-secondary">{item.label}</span>
              <span className="flex-1 text-sm text-text-primary break-words">
                {item.value || '--'}
              </span>
            </div>
          ))}
        </DrawerContent>
      </Drawer>
    </>
  );
};
